import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificateReservationService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllcertificaterReservation(page, size, companyId?: number, status?: boolean, search?: string) {
    console.log(status);
    let queryParams = `Page=${page}&size=${size}`;

    if (companyId) queryParams += `&CompanyId=${companyId}`;
    if (status !== undefined && status !== null) {
      queryParams += `&IsUsed=${status}`;
    } if (search) queryParams += `&search=${search}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.CertificateReservation,
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async getByIdCompanyCertificateReservations(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.CertificateReservation
    }, id);
    return await firstValueFrom(observable);
  }

  async createCertificateReservation(companyId, reservedCertificateNos) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.CertificateReservation
    }, {
      companyId,
      reservedCertificateNos,
      isUsed: false
    });
    return await firstValueFrom(observable);
  }

  async updateCertificateReservation(id, companyId, reservedCertificateNo) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.CertificateReservation
    }, {
      id: id,
      companyId,
      reservedCertificateNo,
      isUsed: false
    });
    return await firstValueFrom(observable);
  }

  async deleteCertificateReservations(ids:number[]){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.CertificateReservation,
      action:"DeleteCertificateReservations"
    },ids);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
